import { MagicStaffIcon } from './MagicStaffIcon';

/**
 * author: Colton Wiscombe
 * id A7255F1C-0207-4202-B1E5-11DC2BED7161
 * name magic-staff
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magic-staff.svg
 * tags
 * - Gaming / RPG 
 */
export const StaffShimmerIcon = MagicStaffIcon;
export default StaffShimmerIcon